export { default } from './FinancialInfoHead';
